import { render } from "./Link.md?vue&type=template&id=ba25fbc6"
const script = {}
script.render = render

export default script